<template>
  <div
    class="notification"
    :class="type"
  >
    <div
      v-if="title.length"
      class="title"
    >
      <Icon
        v-if="iconName.length"
        :name="iconName"
        :fill="iconFill"
        :title="iconName"
      />
      <p>{{ title }}</p>
    </div>
    <div
      v-if="hasSlotData || message.length"
      class="body"
    >
      <Icon
        v-if="iconName.length && !title.length"
        :name="iconName"
        :fill="iconFill"
        :title="iconName"
      />
      <p v-if="message.length">
        {{ message }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Icon from './Icon.vue'

@Options({
  components: {
    Icon,
  },
  props: {
    type: { type: String, default: 'error outline' },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    iconName: { type: String, default: '' },
    iconFill: { type: String, default: 'error' },
  },
  methods: {
    hasSlotData() : boolean {
      return !!this.$slots.default;
    },
  },
})

export default class Notification extends Vue {
  type!: string
  title!: string
  message!: string
  iconName!: string
  iconFill!: string
}
</script>

<style scoped lang="scss">
.notification {
  margin-bottom: 0;
  width: auto;
}
</style>
